export default {"src":"/_next/static/media/dai-ichi-life.5cb44b2c.svg","height":35,"width":119,"blurWidth":0,"blurHeight":0};